export enum MartechFeatureFlags {
  CommunityForum = 'CommunityForumLinksInHeaderAndFooter',
  CowAddTokenAndSignatureToUrl = 'cow-add-token-and-signature-to-url',
  DEPanic = 'DE_Panic',
  FixedPrizeDrawNotificationEnabled = 'FixedPrizeDrawNotificationEnabled',
  FooterDateTime = 'footer_date_time',
  FreeBets = 'freebets',
  FreeSpins = 'eFreeSpinsBonuses',
  Ice2Feature = 'ice2',
  IceFeature = 'eIceFeatureEnabled',
  IceLeaderboard = 'eIceLeaderBoard',
  InstantBonusesVisibility = 'Visibility_MyStars_InstantBonuses',
  LoyaltyWidgetCasinoSports = 'pokerstars-rewards-casino-sports',
  LoyaltyWidgetRefresh = 'Loyalty_WidgetRefresh',
  MiniGameTickets = 'eMiniGameTickets',
  MktgMarketingCommunications = 'mktg-marketing-communications',
  MktgTriggerPendingNotifications = 'mktg-trigger-pending-notifications',
  NoPokerStarsRewards = 'noPokerStarsRewards',
  PRHub = 'PromoExp_PromotionsAndRewards',
  PRHubDesktopPopupOpen = 'PRHUB_popup',
  ReleaseBonuses = 'ReleaseBonuses',
  RewardsStore = 'Visibility_MyStars_RewardsStore',
  ShowJackpotWheel = 'Show-Jackpot-Wheel',
  SportsBonusCash = 'Visibility_MyStars_BonusCash',
  TheDeal = 'the-deal',
  TheDealHighRoller = 'the-deal-highroller',
  VisibilityFeatureTab = 'Visibility_Feature_tab',
  WebMPCNotificationEnabled = 'WebMPCNotificationEnabled',
  WebNotificationEnabled = 'WebNotificationEnabled',
  WebPokerEnabled = 'mktg-web-poker-enabled'
}
